import {IIconProps} from '../DataStoreIcon';

const AzureAppInsights = ({width = '20', height = '20'}: IIconProps) => (
  <svg width={width} height={height} viewBox="0 0 16 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1084_22336)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.7683 7.00208V6.8613C14.7683 3.24901 11.8026 0.246664 8.16248 0.199835C8.07262 0.0590547 6.0054 0.246664 6.0054 0.246664C2.72531 0.669006 0.163746 3.53057 0.163746 6.8613C0.163746 6.95525 -0.195669 9.58208 2.3656 11.7872C3.53399 12.866 4.74716 15.7747 4.92716 16.6191L5.06179 16.9006H9.82521L9.96014 16.6191C10.1398 15.7747 11.3981 12.866 12.5217 11.834C15.0833 9.58208 14.7683 7.09574 14.7683 7.00208Z"
        fill="#68217A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.15186 18.5898H9.91527V20.185H5.15186V18.5898ZM6.63488 23.5625H8.38747L9.87049 21.9206H5.15186L6.63488 23.5625Z"
        fill="#7A7A7A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.70177 16.6657H7.80294V10.7078H7.03904V16.6189H6.1405V10.7078H5.3766C4.47777 10.7078 3.71387 9.91028 3.71387 8.97194C3.71387 8.0336 4.4327 7.23633 5.3766 7.23633C6.3205 7.23633 7.03933 8.03389 7.03933 8.97194V9.7695H7.80323V8.97194C7.80323 8.0336 8.56714 7.23633 9.46596 7.23633C10.3648 7.23633 11.1287 8.03389 11.1287 8.97194C11.1287 9.90999 10.3648 10.7078 9.46596 10.7078H8.70206L8.70177 16.6657ZM5.3766 8.17467C4.97211 8.17467 4.6127 8.50306 4.6127 8.97223C4.6127 9.39457 4.97211 9.76979 5.3766 9.76979H6.1405V8.97223C6.09543 8.55018 5.78109 8.17467 5.3766 8.17467ZM9.46596 8.17467C9.06148 8.17467 8.70206 8.54989 8.70206 8.97223V9.76979H9.46596C9.87045 9.76979 10.2299 9.39457 10.2299 8.97223C10.2299 8.54989 9.91523 8.17467 9.46596 8.17467Z"
        fill="white"
        fillOpacity="0.65"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.16284 0.199835C8.07299 0.0590547 6.00577 0.246664 6.00577 0.246664C2.72538 0.669006 0.164108 3.53057 0.164108 6.8613C0.164108 6.95525 -0.150527 9.25369 1.91669 11.3648L11.6229 1.23184C10.5895 0.575055 9.42108 0.199835 8.16284 0.199835Z"
        fill="white"
        fillOpacity="0.15"
      />
    </g>
    <defs>
      <clipPath id="clip0_1084_22336">
        <rect width="15.2195" height="24" fill="white" transform="translate(0 0.000976562)" />
      </clipPath>
    </defs>
  </svg>
);

export default AzureAppInsights;
